import React from 'react';
import { CheckIcon, LockIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { deliverables, productImage } from '../data/copy';
export function Offer() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="w-full bg-cream" data-id="element-132" data-mp="1mnsb8ey5ui9l">
      <div className="mx-auto w-full max-w-5xl px-5 py-12 sm:px-6 sm:py-16 lg:py-28" data-id="element-133" data-mp="1hopd7egllcb4">
        <div className="mx-auto max-w-2xl text-center" data-id="element-134" data-mp="tyv6zfqsalzu">
          <h2 id="oferta-titulo" className="font-display text-[1.7rem] font-bold leading-tight text-ink sm:text-3xl lg:text-[2.75rem]" data-id="element-135" data-mp="tzd8aqsazqem">
            Recupera tu tranquilidad financiera hoy
          </h2>
          <p className="mt-3 text-[1rem] leading-relaxed text-muted sm:mt-4 sm:text-lg" data-id="element-136" data-mp="yxy0q41bd5si">
            Deja de regalarle dinero a los bancos en intereses altos y toma el control de tu futuro
            en este país.
          </p>
        </div>

        <div id="precio" className="mt-7 scroll-mt-6 overflow-hidden rounded-2xl bg-navy-deep shadow-lift sm:mt-12 sm:scroll-mt-10" data-id="element-137" data-mp="2ac1upa7witxk">
          <div className="grid md:grid-cols-[0.85fr_1.15fr]" data-id="element-138" data-mp="uj1vmes9btpc">
            <div className="hidden bg-navy p-8 md:block" data-id="element-139" data-mp="uhh3swxbuov6">
              <img src={productImage} alt="La guía Crédito Limpio en 30 Días en una tablet" className="w-full rounded-lg" width={1024} height={1024} data-id="element-140" data-mp="zi53s83jag1j" />
            </div>

            <div className="p-6 text-white sm:p-10" data-id="element-141" data-mp="bstxyc7btvgj">
              <p className="text-xs font-semibold uppercase tracking-wide text-gold sm:text-sm" data-id="element-142" data-mp="btlwnvw809b1">
                Sistema completo
              </p>
              <h3 className="mt-1.5 font-display text-2xl font-bold sm:mt-2 sm:text-3xl" data-id="element-143" data-mp="kl4aw19lwf1h">
                “Crédito Limpio en 30 Días”
              </h3>

              <ul className="mt-5 space-y-2.5 sm:mt-6 sm:space-y-3" data-id="element-144" data-mp="3k7ud65lgx9mu">
                {deliverables.map(item => <li key={item.title} className="flex gap-2.5 text-[0.95rem] leading-snug text-white/80 sm:gap-3 sm:text-base" data-id="element-145" data-mp="3o8e9x824qb8g">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-146" data-mp="qg4gpjrw5gf6" />
                    <span data-id="element-147" data-mp="106z6gy4ciy5d">{item.title}</span>
                  </li>)}
              </ul>

              <div className="mt-6 border-t border-white/10 pt-6 sm:mt-8 sm:pt-8" data-id="element-148" data-mp="ch4vyn7i1loa">
                <div className="flex flex-wrap items-end gap-x-4 gap-y-2" data-id="element-149" data-mp="7j3a5uiov894">
                  <span className="pb-1 text-lg font-medium text-white/45 line-through decoration-alert decoration-2 sm:text-xl" data-id="element-150" data-mp="lht8fdh8vdz2">
                    Antes $19.00
                  </span>
                  <span className="inline-flex items-center rounded-full bg-gold px-2.5 py-1 text-[0.7rem] font-bold uppercase tracking-wide text-navy-deep" data-id="element-151" data-mp="1ww6ss8cshbac">
                    Ahorras $12.61
                  </span>
                </div>

                <div className="mt-2 flex items-end gap-3" data-id="element-152" data-mp="20d2nuoshg3r0">
                  <span className="font-display text-5xl font-extrabold leading-none text-gold sm:text-6xl" data-id="element-153" data-mp="25e9wsr6d38z9">
                    $6.39
                  </span>
                  <span className="pb-1 text-[0.8rem] text-white/60 sm:text-sm" data-id="element-154" data-mp="1qikjdhf8s465">
                    Un solo pago.
                    <br data-id="element-155" data-mp="2j555o3gv1q2u" />
                    Acceso de por vida.
                  </span>
                </div>
              </div>

              <CtaButton className="mt-5 w-full sm:mt-7" data-id="element-156" data-mp="2o4htorjgx370" />

              <p className="mt-3.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[0.78rem] text-white/55 sm:mt-4 sm:gap-x-6 sm:text-sm" data-id="element-157" data-mp="2o62ngexyki3t">
                <span className="inline-flex items-center gap-2" data-id="element-158" data-mp="2ed3wwriwihhk">
                  <LockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-159" data-mp="323hfzsjid600" />
                  Pago seguro
                </span>
                <span className="inline-flex items-center gap-2" data-id="element-160" data-mp="36vhnc61wr16m">
                  <DownloadIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-161" data-mp="1j6xorhiuwh1r" />
                  Descarga instantánea
                </span>
                <span data-id="element-162" data-mp="1e5qijmwd3px7">Sin mensualidades ocultas</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}